import { FormatterRegistry } from './registry';
import { createNumberFormatter, formatNumber, formatDelta } from './number';

export const formatterRegistry = FormatterRegistry.createWithDefaults();

export { createNumberFormatter, formatNumber, formatDelta };
export type { FormatterFn, FormatterDef, FieldFormatterConfig } from './types';
export { FormatterRegistry } from './registry';
